var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SummaryField',{attrs:{"label":_vm.label,"has-empty-info-fields":!!_vm.errorMsg,"info-html":_vm.errorMsg}},[_vm._v(_vm._s(_vm.fieldValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }